import type { Relationship } from '@mira/clients-shared';
import { formatDateLabel } from '../../screens/shared.js';
import { Avatar, MiraIcon } from '../primitives/index.js';

export function RelationshipRow(props: { relationship: Relationship; href: string }) {
  const relationship = props.relationship;
  return (
    <a className="mira-relationship-visual-card" href={props.href}>
      <Avatar decorative label={relationship.display_name} />
      <div><h2>{relationship.display_name}</h2>{relationship.relationship_text ? <p className="mira-relationship-kind">{relationship.relationship_text}</p> : null}{relationship.relationship_context ? <p>{relationship.relationship_context}</p> : null}{relationship.updated_at ? <p className="mira-relationship-activity">Updated {formatDateLabel(relationship.updated_at)}</p> : null}</div>
      <span className="mira-row-chevron" aria-hidden="true"><MiraIcon name="action.next" /></span>
    </a>
  );
}
